export function getPreviewUrl(brandId: string, orgId: string) {
  return `https://sagansystems.github.io/help-center/layout-preview?brandId=${brandId}&orgId=${orgId}&cdn=${getCdn()}&api=${
    window.location.origin
  }`;
}

export function getCdn() {
  const hostname = window.location.hostname;
  return /^(.+\.)?gladly.com$/.test(hostname) ? 'https://cdn.gladly.com' : 'https://cdn.gladly.qa';
}
